"use strict";

export function agreeCokie() {
  jQuery("#agreecokie").on("click", function () {
    jQuery.get("/ajax/agreecookie", function (data, status) {
      jQuery("#cookieAlertDiv").hide();
    });
  });
}

export function denyCookie() {
  jQuery("#denyCookie").on("click", function () {
    // jQuery.get("/ajax/denycookie", function (data, status) {
    //     jQuery('#cookieAlertDiv').hide();
    // });

    jQuery("#cookieAlertDiv").hide();
  });
}

// export function acordeonToggle() {
//     jQuery('.accordion-toggle').on('click', function () {
//         jQuery(this).closest('.panel-group').children().each(function () {
//             jQuery(this).find('>.panel-heading').removeClass('active');
//         });
//         jQuery(this).closest('.panel-heading').toggleClass('active');
//     });
// }

const windowH = jQuery(window).height() / 2;

export function scrollToTopBtn() {
  jQuery(window).on("scroll", function () {
    if (jQuery(this).scrollTop() > windowH) {
      jQuery("#myBtn").css("display", "flex");
    } else {
      jQuery("#myBtn").css("display", "none");
    }
  });
}

// export function filterOpener() {
//     jQuery('.filters-opener').on('click', function () {
//         jQuery('jdiv').first().hide();
//     });
// }
//
// export function filterClose() {
//     jQuery('.filters__close-filters').on('click', function () {
//         jQuery('jdiv').first().show();
//     });
// }

// export function btnShowFullMenuMobile() {
//     jQuery('.btn-show-full-menu-mobile').on('click', function () {
//         jQuery(this).toggleClass('is-active');
//         // jQuery('.wrap-side-menu').slideToggle();
//         document.getElementById("myNav").style.width = "100%";
//         jQuery('jdiv').first().hide();
//         jQuery('#at-share-dock').hide();
//     });
// }

// export function closeBtn() {
//     jQuery('.closebtn').on('click', function () {
//         document.getElementById("myNav").style.width = "0%";
//         jQuery('.btn-show-full-menu-mobile').toggleClass('is-active');
//         jQuery('jdiv').first().show();
//         jQuery('#at-share-dock').show();
//     })
// }

export function backToTop() {
  jQuery(".btn-back-to-top").on("click", function () {
    jQuery("html, body").animate({ scrollTop: 0 }, 300);
  });
}

// export function btnShowMenuMobile() {
//     jQuery('.btn-show-menu-mobile').on('click', function () {
//         jQuery(this).toggleClass('is-active');
//         jQuery('.wrap-side-menu').slideToggle();
//     });
// }
//
// const arrowMainMenu = jQuery('.arrow-main-menu');
//
// for (var i = 0; i < arrowMainMenu.length; i++) {
//     jQuery(arrowMainMenu[i]).on('click', function () {
//         jQuery(this).parent().find('.sub-menu').slideToggle();
//         jQuery(this).toggleClass('turn-arrow');
//     })
// }

// export function showMobileSubcategory() {
//     jQuery('.show-mobile-subcategory').on('click', function () {
//         console.warn('DEPRECATED');
//         return;
//         jQuery('#submenu_' + jQuery(this).data('id')).toggle("fast", function () {
//         });
//     })
// }

export function _updateByPost(url, data, myaction) {
  jQuery.ajax({
    type: "POST",
    url: url,
    data: data,
    success: function (response) {
      const res = jQuery.parseJSON(response);
      if (res.success == "true") {
        if (typeof myaction === "function") {
          myaction(response);
        }
      } else {
        jQuery("#pre-order-form-error").css("display", "block");
      }
    },
  });
}

export function _displayIconSuccess() {
  jQuery("#pre-order-form").html("");
  jQuery("#success-checkmark").html(
    '<div class="success-checkmark"><div class="check-icon"><span class="icon-line line-tip"></span><span class="icon-line line-long"></span>' +
      '<div class="icon-circle"></div><div class="icon-fix"></div></div></div>'
  );
}

export function isEmail(email) {
  // var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+jQuery/;
  // return regex.test(email);
  let regex =
    /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+jQuery/;
  if (!regex.test(email)) {
    return false;
  } else {
    return true;
  }
}

// export function jsShowCart() {
//     jQuery('.js-show-cart').on('click', function () {
//         console.log('.js-show-cart');
//         jQuery('.js-panel-cart').addClass('show-header-cart');
//         jQuery('jdiv').first().hide();
//         jQuery('.addthis-smartlayers').hide();
//
//     });
// }

// export function jsHideCart() {
//     jQuery('.js-hide-cart').on('click', function () {
//         console.warn('DEPRECATED');
//         return;
//         jQuery('.js-panel-cart').removeClass('show-header-cart');
//         jQuery('jdiv').first().show();
//         jQuery('.addthis-smartlayers').show();
//
//     });
// }

// export function jsShowSidebar() {
//     jQuery('.js-show-sidebar').on('click', function () {
//         console.warn('DEPRECATED');
//         return;
//         jQuery('.js-sidebar').addClass('show-sidebar');
//         jQuery('.addthis-smartlayers').hide();
//     });
// }

// export function jsHideSidebar() {
//     jQuery('.js-hide-sidebar').on('click', function () {
//         console.warn('DEPRECATED');
//         return;
//         jQuery('.js-sidebar').removeClass('show-sidebar');
//         jQuery('.addthis-smartlayers').show();
//     });
// }

// export function jsShowModalSearch() {
//     jQuery('.js-show-modal-search').on('click', function () {
//         console.warn('DEPRECATED');
//         return;
//         jQuery('.modal-search-header').addClass('show-modal-search');
//         jQuery(this).css('opacity', '0');
//     });
// }

// export function jsHideModalSearch() {
//     jQuery('.js-hide-modal-search').on('click', function () {
//         console.warn('DEPRECATED');
//         return;
//         jQuery('.modal-search-header').removeClass('show-modal-search');
//         jQuery('.js-show-modal-search').css('opacity', '1');
//     });
// }

// export function containerSearchHeader() {
//     jQuery('.container-search-header').on('click', function (e) {
//         console.warn('DEPRECATED');
//         return;
//         e.stopPropagation();
//     });
// }

export default function oldcart() {
  agreeCokie();
  denyCookie();
  // acordeonToggle();
  scrollToTopBtn();
  // filterOpener();
  // filterClose();
  // btnShowFullMenuMobile();
  // resizeWindow();
  // showMobileSubcategory();
  _displayIconSuccess();
  // jsShowCart();
  // jsHideCart();
  // jsShowSidebar();
  // jsHideSidebar();
  // jsShowModalSearch();
  // jsHideModalSearch();
  // containerSearchHeader();
  // closeBtn();
  backToTop();
  // btnShowMenuMobile();
}
